module.exports = __webpack_public_path__ + "img/works_kyobo_btm_m.42f1b411.jpg";